/* global debounce */

if (!customElements.get('search-form')) {
  class SearchForm extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.js-search-input');
      this.productTypeSelect = this.querySelector('.js-search-product-types');
      this.productTypeInput = document.getElementById('product_type_input');
      this.resetBtn = this.querySelector('.js-search-reset');
      this.placeholderTimer = null;
      this.addListeners();
    }

    connectedCallback() {
      this.init();
    }

    addListeners() {
      this.input.addEventListener('input', debounce(this.handleInput.bind(this)));
      if (this.productTypeSelect) {
        this.productTypeSelect.addEventListener('change', this.handleProductTypeChange.bind(this));
      }
      this.resetBtn.addEventListener('click', this.handleReset.bind(this));
    }

    init() {
      if ((this.input.dataset.placeholderTwo || this.input.dataset.placeholderThree)
        && (this.input.dataset.placeholderPromptsMob === 'true' || theme.mediaMatches.md)) {
        this.typeInPlaceholders();
      }
    }

    disconnectedCallback() {
      if (this.placeholderTimer !== null) {
        window.clearInterval(this.placeholderTimer);
        this.placeholderTimer = null;
      }
    }

    /**
     * Rotates complete placeholder prompts at a calm interval. This keeps all
     * merchant-configured prompts without continuously rewriting the DOM.
     */
    typeInPlaceholders() {
      if (this.placeholderTimer !== null) return;

      const placeholders = [];

      if (this.input.placeholder) {
        placeholders.push(this.input.placeholder);
      }

      if (this.input.dataset.placeholderTwo) {
        placeholders.push(this.input.dataset.placeholderTwo);
      }

      if (this.input.dataset.placeholderThree) {
        placeholders.push(this.input.dataset.placeholderThree);
      }

      if (
        placeholders.length < 2 ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ) {
        return;
      }

      const configuredDelay = Number(
        this.input.dataset.delayAfterWordTyped
      );
      const rotationDelay = Number.isFinite(configuredDelay)
        ? Math.max(5000, configuredDelay)
        : 5000;
      let placeholderIndex = 0;

      this.placeholderTimer = window.setInterval(() => {
        if (
          document.hidden ||
          document.activeElement === this.input ||
          this.input.value.length > 0
        ) {
          return;
        }

        placeholderIndex = (placeholderIndex + 1) % placeholders.length;
        this.input.setAttribute(
          'placeholder',
          placeholders[placeholderIndex]
        );
      }, rotationDelay);
    }

    /**
     * Handles 'input' events on the search field.
     */
    handleInput() {
      if (this.input.value.length > 0) {
        this.input.classList.add('search__input--dirty');
      } else {
        this.input.classList.remove('search__input--dirty');
      }
    }

    /**
     * Handles a change of product type
     * @param {object} evt - Event object.
     */
    handleProductTypeChange(evt) {
      this.productTypeInput.value = evt.detail.selectedValue;
    }

    /**
     * Handles the reset button being clicked
     */
    handleReset() {
      this.input.classList.remove('search__input--dirty');
    }
  }

  customElements.define('search-form', SearchForm);
}
